export default "__VITE_ASSET__DDa6IcGl__"